export default __webpack_public_path__ + "static/media/school3.73705149.webp";